module.exports = __webpack_public_path__ + "img/lg_ring_g_l_1_null@2x.308820fc.png";